export default {
  throttle: function(func,delay){
    var timer = null;
    var startTime = Date.now();
  
    return function(){
        var curTime = Date.now();
        var remaining = delay-(curTime-startTime);
        var context = this;
        var args = arguments;
  
        clearTimeout(timer);
        if(remaining<=0){
            func.apply(context,args);
            startTime = Date.now();
        }else{
            timer = setTimeout(func,remaining);
        }
    }
  },
  lazyloadPicture: function (toShowHeight = 100) {
    function lazyload (height) {
      var limitTop = $(window).height() + $(window).scrollTop() + height
      $('.lazyload').each(function () {
        if ($(this).offset().top < limitTop) {
          var tagName = $(this)[0].tagName.toLowerCase();
          if (tagName === 'picture') {
            $(this).find('source').each(function () {
              $(this).attr('srcset', $(this).data('src'))
            });
            $(this).find('img').each(function () {
              $(this).attr('src', $(this).data('src'))
            });
          } else {
            $(this).attr('src', $(this).data('src'))
          }
          $(this).removeClass('lazyload')
        }
      });
    }

    lazyload(toShowHeight);
    $(window).scroll(this.throttle(function  () {
      lazyload(toShowHeight);
    }, 600));
  },
  goToTop: function () {
    const showDist = 300;
    $(window).scroll(function  () {
      if($(window).scrollTop() > showDist){
        $('.go-to-top-btn').fadeIn(200);
      }
      else{
        $('.go-to-top-btn').fadeOut(200);
      }
    });
    $('.go-to-top-btn').on('click',function  () {
      $('html,body').animate({scrollTop:0}, 500,function  () {
        $('.go-to-top-btn').fadeOut();
      });
    });
  }
}